import 'amkit3-modules/utils/sentry'

interface VideoTimeInfo {
  videoLoadStart: number
  videoLoadEnd: number
  'init-playend': number
  'init-infostart': number
  'infoend-infostart': number
  'beforeplay-infoend': number
  'playstart-beforeplay': number
  'playend-playstart': number
}

// 扩展 Window 接口，声明自定义属性
declare global {
  interface Window {
    HuyaPlayer: typeof HuyaPlayer
    huyaPlayer: HuyaPlayer
    jumpMovie: (value: any) => void
    videoDefinitions: any
    videoData: any
    playRoomConfig: any
    playerLoadStart: number
    playerLoadEnd: number
    performanceInfo: any
  }
}

const HuyaPlayerConstructor = require('amkit3-modules/v/player/huya')['default']
class HuyaPlayer {
  player: any
  timer: any
  private initQueue: Function[] = []
  private isInitialized: boolean = false

  constructor(container: any, options: any, cb?: (err?: any) => void) {
    cb = cb ? cb : () => {}
    try {
      console.log('options', options)
      this.init(container, options, (err?: any) => {
        if (!err) {
          clearTimeout(this.timer)
          this.isInitialized = true
          this.processQueue()
        }
        cb.call(this, err)
      })
      // 异常兜底触发
      this.timer = setTimeout(() => {
        if (!this.isInitialized) {
          this.isInitialized = true
          this.processQueue()
        }
      }, 2000)
    } catch (err) {
      cb.call(this, err)
    }
  }

  /**
   * 播放器加载完回调
   * @param fn
   */
  videoOnLoad(fn: Function) {
    if (this.isInitialized) {
      fn()
    } else {
      this.initQueue.push(fn)
    }
  }

  private processQueue() {
    while (this.initQueue.length) {
      const fn = this.initQueue.shift()
      try {
        fn?.()
      } catch (err) {
        console.error('Error executing queued function:', err)
      }
    }
  }
  init(container: any, options: any, cb: (err?: any) => void) {
    this.player = new HuyaPlayerConstructor(container, options, (err?: any) => {
      if (err) {
        console.log('initial player err', err)
        cb.call(this, err)
      } else {
        cb.call(this, null)
      }
    })
  }
  seek(value: any) {
    if (this.player) this.player.seek(value)
  }
}
window.HuyaPlayer = HuyaPlayer

const initVideo = () => {
  if (window.videoDefinitions && window.videoData) {
    const videoData = window.videoData
    const videoDefinitions = window.videoDefinitions
    const playerInitBefore = Date.now()
    let reportCacheTimer: NodeJS.Timeout | null = null
    const platform = 'vhuyaweb'
    const options: Record<string, unknown> = {
      channelId: 'ycvideo' === videoData.channelId ? '' : videoData.channelId,
      auto_play: 1,
      vid: videoData.vid,
      no_danmu: 0,
      from: platform,
      enableH265: true,
      source: 'play',
      videoDefinitions: videoDefinitions.value || [],
      videoData: videoData || '',
      playerConfig: window?.playRoomConfig?.playerConfig || '',
      // fluid: false,
    }
    console.log('player options', options)
    const vWrap = document.getElementById('video_embed_flash')
    vWrap && (vWrap.innerHTML = '')
    const pageview = 'huya_video'
    console.log('vWrap11', vWrap)
    window.huyaPlayer = new window.HuyaPlayer(vWrap, options, function (err: any) {
      if (err) {
        console.log('player initialize failed', err)
      } else {
        const playerInitAfter = Date.now()
        const player = window.huyaPlayer.player.core
        const navigator = window.navigator as any
        const networkType =
          (navigator && navigator.connection && navigator.connection.effectiveType) || 'UNKNOWN'
        let definition: any = null
        //秒开上报
        player.afertLoadingVideo &&
          player.afertLoadingVideo(function (videoLoadTiming: VideoTimeInfo, newDefinition: any) {
            console.log('videoLoadTiming', videoLoadTiming)
            definition = newDefinition
            if (!('performance' in window)) return
            var perfTiming = performance.timing
            const videoLoadStart = videoLoadTiming.videoLoadStart
            const videoLoadEnd = videoLoadTiming.videoLoadEnd
            console.log('timeing-videoLoadEnd', videoLoadEnd - perfTiming.fetchStart)
            console.log('timeing-videoLoadStart', videoLoadEnd - videoLoadStart)
            console.log(
              'timeing-init',
              videoLoadEnd - playerInitAfter,
              videoLoadEnd - videoLoadStart,
            )

            var timemap = [
              perfTiming.domainLookupStart - perfTiming.fetchStart, // App cache
              perfTiming.domainLookupEnd - perfTiming.domainLookupStart, // DNS
              perfTiming.connectEnd - perfTiming.connectStart, // TCP
              perfTiming.responseStart - perfTiming.requestStart, // Request
              perfTiming.responseEnd - perfTiming.responseStart, // Respone
              perfTiming.domContentLoadedEventStart - perfTiming.domLoading, // DomContentLoad
              window.playerLoadEnd - window.playerLoadStart, // PlayerLoad
              videoLoadEnd - videoLoadStart, // VideoLoad
              perfTiming.responseEnd - perfTiming.fetchStart,
              perfTiming.responseEnd - perfTiming.connectStart,
              window.playerLoadStart - perfTiming.connectStart,
              videoLoadEnd - perfTiming.connectStart,
              videoLoadEnd - window.playerLoadStart,
              window.playerLoadStart - perfTiming.domLoading,
              playerInitAfter - playerInitBefore,
            ]
            const timing = [
              { path: 'AppCache', value: timemap[0] },
              { path: 'DNS', value: timemap[1] },
              { path: 'TCP', value: timemap[2] },
              { path: 'Request', value: timemap[3] },
              { path: 'Respone', value: timemap[4] },
              { path: 'DomContentLoad', value: timemap[5] },
              { path: 'PlayerLoad', value: timemap[6] },
              { path: 'VideoLoad', value: timemap[7] },
              { path: 'fetchStart-responseEnd', value: timemap[8] },
              { path: 'connectStart-responseEnd', value: timemap[9] },
              {
                path: 'connectStart-playerLoadStart',
                value: timemap[10],
              },
              { path: 'connectStart-videoLoadEnd', value: timemap[11] },
              {
                path: 'playerLoadStart-videoLoadEnd',
                value: timemap[12],
              },
              {
                path: 'domLoading-playerLoadStart',
                value: timemap[13],
              },
              {
                path: 'playerInitBefore-playerInitAfter',
                value: timemap[14],
              },
              {
                path: 'whiteScreenTime',
                value: window.performanceInfo.whiteScreenTime - perfTiming.fetchStart,
              },
              {
                path: 'firstScreenTime',
                value: window.performanceInfo.firstScreenTime - perfTiming.fetchStart,
              },
              {
                path: 'readyTime',
                value: perfTiming.domContentLoadedEventEnd - perfTiming.fetchStart,
              },
              {
                path: 'fetchStart-videoLoadEnd',
                value: videoLoadEnd - perfTiming.fetchStart,
              },
              {
                path: 'fetchStart-playerInitBefore',
                value: playerInitBefore - perfTiming.fetchStart,
              },
              {
                path: 'playerLoadEnd-playerLoadStart',
                value: window.playerLoadEnd - window.playerLoadStart,
              },
              {
                path: 'beforeplay-infoend',
                value: videoLoadTiming['beforeplay-infoend'],
              },
              {
                path: 'infoend-infostart',
                value: videoLoadTiming['infoend-infostart'],
              },
              {
                path: 'init-infostart',
                value: videoLoadTiming['init-infostart'],
              },
              {
                path: 'playstart-beforeplay',
                value: videoLoadTiming['playstart-beforeplay'],
              },
              {
                path: 'init-playend',
                value: videoLoadTiming['init-playend'],
              },
              {
                path: 'playend-playstart',
                value: videoLoadTiming['playend-playstart'],
              },
            ]
            console.log('timing', timing)
            var performanceTarget = {
              pageview: pageview,
              schema: 'play-' + definition?.format || 'unknown',
              effectiveType: networkType,
              playerVersion: window?.playRoomConfig?.playerVersion || '0',
              m: timing,
            }
            window.performanceInfo._hmt.push(['reportCustomData', performanceTarget])
            // 自定义上报，上报到vod.tx_vod_load_time表
            window.performanceInfo._hmt.push([
              'reporCustomIndex',
              {
                name: 'vod.tx_vod_load_time',
                dim: {
                  vid: String(videoData.vid),
                  url: player.getCDNURL(),
                  platform: platform,
                  format: definition?.format || 'unknown',
                  pageurl: location.href,
                  duration: String(player.getDuration()),
                  network_type: networkType,
                },
                field: {
                  value: Number(videoLoadEnd - perfTiming.fetchStart),
                },
                extdesc: '',
              },
            ])
          })
        //黑屏上报
        let reportTimer: NodeJS.Timeout | null = null

        const reportNoPicture = () => {
          reportTimer = setTimeout(() => {
            console.log('上报黑屏', Number(!player.playback.hasPlayed))
            window.performanceInfo._hmt.push([
              'reporCustomIndex',
              {
                name: 'web.video.vod_no_picture_ratio',
                dim: {
                  vid: String(videoData.vid),
                  url: player.getCDNURL(),
                  platform: platform,
                  format: definition?.format || 'unknown',
                  pageurl: location.href,
                  duration: String(player.getDuration()),
                  network_type: networkType,
                },
                field: {
                  value: Number(!player.playback.hasPlayed),
                },
                extdesc: '',
              },
            ])
          }, 10000)
        }

        const clickPlay = () => {
          player.once('CLICK_PLAY', () => {
            reportNoPicture()
          })
        }

        //可自动播放的场景直接延迟10s上报，不可自动播放的场景在用户点击播放后再计时上报
        // 默认触发上报
        reportNoPicture()

        // 当触发 BROWSER_PAUSE 时，取消自动上报，改为等待用户点击
        player.once('BROWSER_PAUSE', () => {
          if (reportTimer) {
            clearTimeout(reportTimer)
            reportTimer = null
          }
          clickPlay()
        })

        //卡顿上报
        let cacheTime = 0
        let isCaching = false
        player.on('V-PLAYBACKS-PLAYBACKEVENT-BUFFERING', () => {
          if (!isCaching) {
            cacheTime++
          }
          isCaching = true
          console.log(cacheTime)
        })
        player.on('V-PLAYBACKS-PLAYBACKEVENT-NOT_BUFFERING', () => {
          isCaching = false
        })
        const loopReportCache = () => {
          reportCacheTimer = setTimeout(() => {
            if (player.playback.state === 'playing') {
              window.performanceInfo._hmt.push([
                'reporCustomIndex',
                {
                  name: 'web.video.vod_bad_quality',
                  dim: {
                    vid: String(videoData.vid),
                    url: player.getCDNURL(),
                    platform: platform,
                    format: definition?.format || 'unknown',
                    pageurl: location.href,
                    duration: String(player.getDuration()),
                    network_type: networkType,
                  },
                  field: {
                    value: cacheTime,
                  },
                  extdesc: '',
                },
              ])
              cacheTime = 0
            }
            loopReportCache()
          }, 20000)
        }
        loopReportCache()
      }
    })
    window.jumpMovie = function (value) {
      window.huyaPlayer.seek(value)
    }
  }
}
// 非付费视频
if (!window.videoData?.extParam?.value?.payment_package_id) {
  initVideo()
}
export default HuyaPlayer
